import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=ed0f578a&"
import script from "./Survey.vue?vue&type=script&lang=ts&"
export * from "./Survey.vue?vue&type=script&lang=ts&"
import style0 from "./Survey.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports